import * as React from 'react';
import { flow, get } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { IAuthState } from '../../../../../../services/auth/models';
import { Link } from 'react-router-dom';
import { IMtaActions, IMtaState } from '../../../../../../services/mta/models';
import { push } from 'react-router-redux';
import MTADeclarationForm from './scenes/MTADeclarationForm';
import { ICustomerMTAOptions } from '../../index';
import { mtaActions } from '../../../../../../services/mta/actions';
import { MTACardHeader } from './scenes/Components/MTACardHeader';
import { MTAButtons } from '../MTAButtons';
import { Button } from 'react-bootstrap';
import { LoadingSpinner } from '../../../../../../components/LoadingSpinner';
import { parse } from 'date-fns';

interface ICoverDetailsProps {
  auth: IAuthState;
  mta: IMtaState;
  isLoading: boolean;
  customerMTAOptions: ICustomerMTAOptions;
  actions: {
    push(path: string);
    mta: IMtaActions;
  };
}

interface ICoverDetailsState {
  allowedMta: boolean;
}

class CoverDetails extends React.Component<ICoverDetailsProps, ICoverDetailsState> {

  constructor(props) {
    super(props);

    this.state = {
      allowedMta: false,
    };
  }

  public componentDidMount() {
    this.canCustomerUpdateCoverDetails();
  }

  private canCustomerUpdateCoverDetails = () => {
    const { mta } = this.props;
    const isSTPolicy = get(mta, 'selectedPolicy.metadata.scheme_type', '') === 'single';
    const isAMTPolicy = get(mta, 'selectedPolicy.metadata.scheme_type', '') === 'annual';
    if (mta.selectedPolicy && isSTPolicy) {
      const today = new Date();
      const policyCommencesAt = parse(mta.selectedPolicy.commencesAt, 'dd/MM/yyyy', new Date());
      this.setState({ allowedMta: today < policyCommencesAt });
    } else if (mta.selectedPolicy && isAMTPolicy) {
      const hasRenewal = get(mta, 'policyInfo.meta.hasRenewal', false);
      if (hasRenewal) {
        this.setState({ allowedMta: false });
      } else {
        this.setState({ allowedMta: true });
      }
    } else {
      this.setState({ allowedMta: true });
    }
  }

  public render() {
    const { isLoading } = this.props;

    if (isLoading) {
      return (
        <LoadingSpinner text={'Getting your details...'}/>
      )
    }

    const goBackButton = (
      <Link to="/account/make-a-change">
        <Button
          bsStyle={'primary'}
          className={'secondary-button'}>
          GO BACK
        </Button>
      </Link>
    );

    if (!this.state.allowedMta) {
      return (
        <div className="page-container mt-30">
          <MTACardHeader text={'Make a Change - Update Cover Details'}/>
          <div className={'white-card'}>
            <p>Sorry, we are unable to make the change requested as your trip has already started.</p>
            <p>
              If you’d like to discuss anything please <a href={'https://www.admiral.com/contact-us/travel'}
                                                          target={'_blank'}>get in touch</a>.
            </p>
          </div>


          <div className="mt-15"/>
          <MTAButtons button1={goBackButton}/>
        </div>
      )
    }

    return (
      <>
        <MTADeclarationForm redirectUrl={'/account/make-a-change/mta/select'}/>
      </>
    );
  }

}

export default flow([
  connect(
    (state: IStore) => {
      return {
        mta: state.mta,
        auth: state.auth,
        isLoading: state.mta.isLoading,
        customerMTAOptions: get(state.branding.channel.products[0], 'metadata.direct_customer_mta_options', null),
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        mta: bindActionCreators({ ...mtaActions }, dispatch),
      },
    }),
  ),
])(CoverDetails);
